import { FlightData } from '../types'
import { getCurrentFlight, getStatusLabel, translateStatus } from './utils'
import { t } from 'i18next'

interface Props {
  elementId: string,
  layout: string
}

export class FlightViewMapLibTrackerHeader {
  elementId: string
  layout: string

  constructor({ elementId, layout }: Props) {
    this.elementId = elementId
    this.layout = layout
  }

  update (flights: FlightData[]) {
    const headerElement = document.getElementById(this.elementId)
    if (!headerElement) return

    let child = headerElement.lastElementChild
    while (child) {
      headerElement.removeChild(child)
      child = headerElement.lastElementChild
    }
    const currentFlight = getCurrentFlight(flights)
    headerElement.className = `FVLib-status-${currentFlight.status[0].toLowerCase()} FVLib-status-${currentFlight.status[1].toLowerCase()} FVLib-header`
    this.createSummaryHeader(headerElement, flights)
  }

  createSummaryHeader (header: HTMLElement, flights: FlightData[]) {
    const currentFlight = getCurrentFlight(flights)
    const flightId = currentFlight.flightId

    const infoDiv = document.createElement('div')
    infoDiv.className = 'FVLib-header-data'
    header.appendChild(infoDiv)

    const airlineInfoDiv = document.createElement('div')
    airlineInfoDiv.className = 'FVLib-header-data-item FVLib-header-airlines'
    infoDiv.appendChild(airlineInfoDiv)

    const flightAirLineAndStatus = document.createElement('span')
    if (flightId.airlineName) {
      if (this.layout && this.layout === '2023v1') {
        flightAirLineAndStatus.innerText = `${flightId.airlineName} ${flightId.flightNumber}`
      } else {
        flightAirLineAndStatus.innerText = `${flightId.airlineName} #${flightId.flightNumber} (${flightId.airlineCode}${flightId.flightNumber})`
      }
    } else {
      flightAirLineAndStatus.innerText = `${flightId.airlineCode}${flightId.flightNumber}`
    }
    flightAirLineAndStatus.className = 'FVLib-header-info'
    airlineInfoDiv.appendChild(flightAirLineAndStatus)

    if (this.layout && this.layout === '2023v1') {
      const hrDiv = document.createElement('div')
      hrDiv.className = 'FVLib-header-data-item FVLib-header-hr'
      const hr = document.createElement('hr')
      hrDiv.appendChild(hr)
      infoDiv.appendChild(hrDiv)
    }

    const status = (this.layout !== '2023v1') ? translateStatus(currentFlight) : null

    if (currentFlight.flightId.codeShare || currentFlight.flightId.regionalCarrier) {
      const flightCodeShare = document.createElement('span')
      const flightObj = (currentFlight.flightId.codeShare) ? currentFlight.flightId.codeShare : currentFlight.flightId.regionalCarrier
      flightCodeShare.innerText = `${t('TRACKER.FLIGHT_PART.HEADER_OPERATED_AS')} ${flightObj.airlineName} ${flightObj.flightNumber}`
      flightCodeShare.className = 'FVLib-header-label'
      airlineInfoDiv.appendChild(flightCodeShare)
    }

    const flightStatusDiv = document.createElement('div')
    flightStatusDiv.className = 'FVLib-header-data-item FVLib-header-status'
    infoDiv.appendChild(flightStatusDiv)

    const flightSummaryStatus = document.createElement('span')
    flightSummaryStatus.innerText = getStatusLabel(currentFlight, true)
    flightSummaryStatus.className = 'FVLib-header-info'
    flightStatusDiv.appendChild(flightSummaryStatus)

    if (status) {
      const flightStatus = document.createElement('span')
      flightStatus.innerText = `${status.replace('minutes', t('TRACKER.FLIGHT_PART.HEADER_MINUTES'))}`
      flightStatus.style.fontStyle = 'italic'
      flightStatus.className = 'FVLib-header-label'
      flightStatusDiv.appendChild(flightStatus)
    }

    // following hidden element is for FVAccess compatibility
    const flightStatusCompat = document.createElement('div')
    flightStatusCompat.id = 'ffStatusSummary'
    flightStatusCompat.style.display = 'none'
    flightStatusCompat.innerText = `${t('TRACKER.FLIGHT_PART.HEADER_STATUS_LABEL', { status })}`
    infoDiv.appendChild(flightStatusCompat)
  }

  formatAirportName (nameStr: string): string {
    let newNameStr = ''
    const nameArray = nameStr.split('')
    const alphaChar = /^[a-zA-z]/
    let toLower = false

    for (let i = 0; i < nameArray.length; i++) {
      const thisChar = nameArray[i]
      if (toLower) {
        newNameStr += thisChar.toLowerCase()
      } else {
        newNameStr += thisChar
      }
      toLower = alphaChar.test(thisChar)
    }

    return newNameStr
  }
}
